import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import { NotificationBar } from '@eb/eds-notification';
import { Button } from '@eb/eds-button';

import './AuthNotification.scss';

const AuthNotification = ({ authNotificationOptions, handleOnClick }) => {
    const _handleOnClick = () => {
        const { onClick } = authNotificationOptions;
        handleOnClick(onClick);
    };
    let component = null;

    if (!isEmpty(authNotificationOptions)) {
        const {
            message,
            onClick,
            buttonCTA,
            ...props
        } = authNotificationOptions;
        let buttonComponent = null;

        if (onClick) {
            buttonComponent = (
                <Button onClick={_handleOnClick} type="button" style="anchor">
                    {buttonCTA}
                </Button>
            );
        }

        component = (
            <div className="authentication__notification-container eds-l-mar-bot-4 eds-fx--bounce">
                <NotificationBar {...props}>
                    {message}
                    {buttonComponent}
                </NotificationBar>
            </div>
        );
    }

    return component;
};

AuthNotification.propTypes = {
    authNotificationOptions: PropTypes.shape({
        message: PropTypes.node,
        type: PropTypes.string,
        iconType: ICON_TYPE_PROP_TYPE,
    }),
};

export default AuthNotification;
